function resolveApiURL() {
  const configuredBaseHost =
    import.meta.env.VITE_API_BASE_HOST || import.meta.env.REACT_APP_BASE_HOST

  if (configuredBaseHost) {
    return configuredBaseHost
  }

  if (typeof window !== 'undefined') {
    const { hostname } = window.location

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return ''
    }

    if (hostname.endsWith('.localhost')) {
      return 'https://elev.localhost'
    }
  }

  return 'https://elev.asku.no'
}

export const apiURL = resolveApiURL()

export interface Config extends RequestInit {
  data?: Record<string, unknown>
}

export type Client = (path: string, config?: Config) => Promise<unknown>

const client: Client = async (
  endpoint: string,
  { data, headers: customHeaders, ...customConfig } = {}
) => {
  const headers: HeadersInit = {}
  if (data) {
    headers['Content-Type'] = 'application/json'
  }

  const config: RequestInit = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      ...headers,
      ...customHeaders,
    },
    ...customConfig,
  }

  const response = await fetch(`${apiURL}${endpoint}`, config)
  const content = await jsonOrText(response)

  if (!response.ok) {
    throw new APIError(response.status, content)
  }

  return content
}

async function jsonOrText(response: Response) {
  if (response.headers.get('Content-Type')?.includes('application/json')) {
    return response.json()
  } else {
    return response.text()
  }
}

export class APIError extends Error {
  constructor(
    public status: number,
    public data: unknown
  ) {
    super(`API Error ${status}: ${JSON.stringify(data)}`)
  }
}

export default client
